var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-return"},[_c('div',{staticClass:"btn"},[_c('van-icon',{attrs:{"name":"arrow-left","size":"22"},on:{"click":function($event){return _vm.$router.back()}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }